import { environment, Environment } from 'src/environments/environment';
import { HttpResponse, HttpClient } from '@angular/common/http';
import { Observable, of, throwError } from 'rxjs';
import { AlertService } from '@app/shared/services/alert/alert.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
@Injectable({ providedIn: 'root' })
export abstract class BaseService {
    public api: string;
    public environment: Environment = environment;

    constructor(private alertService: AlertService, public http: HttpClient) {
        this.api = this.environment.API_ENDPOINT;
    }

    /**
     * Handle Http operation that failed.
     * Let the app continue.
     * @param operation - name of the operation that failed
     * @param result - optional value to return as the observable result
     */
    public handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {
            // console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            const erro = error.error;
            switch (error.status) {
                case 0:
                    this.log(`Erro ao contatar o servidor`, 'alert');
                    break;
                case 422:
                    if (erro && erro.errors) {
                        const arr = [];
                        Object.keys(erro.errors).map(function (key) {
                            arr.push(erro.errors[key].join(','));
                            return arr;
                        });
                        const erros = arr.reduce(function (acc, curr, index) {
                            return index === 0 ? curr : acc + '\n' + curr;
                        });
                        this.log(`${erros}`, 'console');
                    } else if (erro && erro.message) {
                        this.log(`${erro.message}`, 'console');
                    }
                    break;
                case 401:
                    this.log(`Acesso Negado, Favor logar novamente`, 'alert');
                    break;
                case 400:
                    if ('message' in erro) {
                        this.log(`${erro.message}`, 'console');
                    } else {
                        this.log(`${erro.error}`, 'console');
                    }
                    break;

                default:
                    this.log(
                        `${operation} failed: ${error.message}`,
                        'console'
                    );
                    break;
            }
            return throwError(error);
            // throwError(error);
        };
    }

    /** Log a HeroService message with the MessageService */
    public log(message: string, type: string = 'alert') {
        if (type === 'alert') {
            this.alertService.error(
                `${this.constructor.name}: ${message}`,
                this.alertService.ANIMATE_FROM_LEFT
            );
        }
        if (type === 'console') {
            console.error(
                `${this.constructor.name}: ${message}`,
                this.alertService.ANIMATE_FROM_LEFT
            );
        }
    }

    printPdf(response: HttpResponse<Blob>) {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.contentWindow.print();
    }

    printPdfFromBase64(base64: string) {
        if (!base64) return;

        const cleaned = String(base64).includes(',')
            ? String(base64).split(',').pop()
            : String(base64);

        const binaryString = window.atob(cleaned);
        const len = binaryString.length;
        const bytes = new Uint8Array(len);

        for (let i = 0; i < len; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }

        const blob = new Blob([bytes], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);
        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = blobUrl;
        document.body.appendChild(iframe);

        iframe.onload = () => {
            if (iframe.contentWindow) {
                iframe.contentWindow.focus();
                iframe.contentWindow.print();
            }

            setTimeout(() => {
                URL.revokeObjectURL(blobUrl);
                iframe.remove();
            }, 1000);
        };
    }

    printPdfMobile(response: HttpResponse<Blob>) {
        const blob = new Blob([response.body], { type: 'application/pdf' });
        const blobUrl = URL.createObjectURL(blob);

        window.open(blobUrl, '_blank');

        // Muitos navegadores móveis (como Safari no iOS ou Chrome no Android) bloqueiam ou ignoram chamadas print() automáticas, especialmente dentro de iframes.
    }
    saveFile(response: HttpResponse<Blob>) {
        const contentDisposition = response.headers.get('content-disposition');
        let fileName = 'arquivo.png'; // nome padrão

        if (contentDisposition) {
            // tenta pegar filename*= (UTF-8)
            const utf8Match = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(
                contentDisposition
            );
            if (utf8Match && utf8Match[1]) {
                fileName = decodeURIComponent(utf8Match[1]);
            } else {
                // tenta pegar filename=
                const asciiMatch = /filename\s*=\s*"?([^"]+)"?/i.exec(
                    contentDisposition
                );
                if (asciiMatch && asciiMatch[1]) {
                    fileName = asciiMatch[1];
                }
            }
        }

        const blob = response.body;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');

        link.href = url;
        link.setAttribute('download', fileName);
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    downloadXLS(URL, content, nameFile) {
        const httpOption: Object = {
            observe: 'response',
            responseType: 'arraybuffer'
        };

        this.http
            .post<any>(URL, content, httpOption)
            .pipe(
                map((res: HttpResponse<any>) => {
                    return {
                        filename: nameFile + '.xlsx',
                        data: new Blob([res['body']], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                        })
                    };
                })
            )
            .subscribe(
                (res) => {
                    const link = window.URL.createObjectURL(res.data);
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = link;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(link);
                    a.remove();
                },
                (error) => {
                    throw error;
                },
                () => {
                    console.log('Completed file download.');
                }
            );
    }

    downloadPDF(URL: string, content: any, nameFile: string) {
        const httpOption: Object = {
            observe: 'response',
            responseType: 'arraybuffer'
        };

        this.http
            .post<any>(URL, content, httpOption)
            .pipe(
                map((res: HttpResponse<any>) => {
                    return {
                        filename: nameFile + '.pdf',
                        data: new Blob([res.body], { type: 'application/pdf' })
                    };
                })
            )
            .subscribe(
                (res) => {
                    const link = window.URL.createObjectURL(res.data);
                    const a = document.createElement('a');
                    document.body.appendChild(a);
                    a.setAttribute('style', 'display: none');
                    a.href = link;
                    a.download = res.filename;
                    a.click();
                    window.URL.revokeObjectURL(link);
                    a.remove();
                },
                (error) => {
                    throw error;
                },
                () => {
                    this.alertService.success('Completed file download.');
                }
            );
    }
}
